import React, { useEffect } from 'react';
import { fetchStoreInfoBySubDomain } from 'src/redux/actions';
import Error404 from '@/containers/404Page/index';
import { useDispatch } from 'react-redux';
import { isWebsiteInternallyRouted } from 'src/utils/isWebsiteInternallyRouted';

const ErrorPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const isCustomDomain = isWebsiteInternallyRouted(window.location.host);
    const domainName = `${isCustomDomain ? 'd-' : ''}${window.location.host.replace('www.', '')}`;
    dispatch(fetchStoreInfoBySubDomain(domainName));
  }, []);

  return (
    <>
      <Error404 />
    </>
  );
};

export default ErrorPage;
